"use client";

import { ArrowDown, ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SpeakerToolkit() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const projectMeta = [{
    label: "TOPIC",
    value: "RESILIENCE MINDSET"
  }, {
    label: "AUDIENCE",
    value: "FORTUNE 500 EXEC"
  }, {
    label: "FORMAT",
    value: "KEYNOTE / 60 MIN"
  }, {
    label: "AVAILABILITY",
    value: "Q3-Q4 2024"
  }, {
    label: "IMPACT",
    value: "LEADERSHIP GROWTH"
  }, {
    label: "LOCATION",
    value: "GLOBAL / VIRTUAL"
  }];
  return <section data-section-id="4166" id="speaker-toolkit" className="relative bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_keynote_stage_performance.png)]" />

      {}
      <div className="absolute inset-0" style={{
      background: "linear-gradient(90deg, hsla(215,25%,10%,0.95) 0%, hsla(215,25%,10%,0.85) 35%, hsla(215,25%,10%,0.6) 65%, hsla(215,25%,10%,0.3) 100%)"
    }} />

      {}
      <div className="absolute inset-0 opacity-[0.05] mix-blend-overlay pointer-events-none" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
    }} />

      {}
      <div className="absolute top-0 left-0 right-0 h-px bg-primary/20" />

      {}
      <div className="absolute top-8 right-6 md:right-12 z-10 font-mono text-[11px] tracking-widest text-primary/60">
        RESOURCES / 06
      </div>

      <div className="relative z-10 px-6 md:px-12 lg:px-16 py-24 md:py-32 lg:py-40">
        <div className="grid grid-cols-12 gap-6 lg:gap-8 max-w-[1600px] mx-auto">
          {}
          <div ref={contentRef} className={`col-span-12 lg:col-span-7 transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="flex items-center gap-3 mb-10 md:mb-14">
              
              
            </div>

            {}
            <h2 className="font-default font-black uppercase leading-[0.85] tracking-tighter text-foreground mb-12 md:mb-16" style={{
            fontSize: "clamp(4rem, 10vw, 10rem)"
          }}>
              <span className="block">LEAD /</span>
              <span className="block">WITH /</span>
              <span className="block font-default font-black" style={{
              WebkitTextStroke: "1.5px hsl(45 100% 50%)",
              color: "transparent"
            }}>
                POWER.
              </span>
            </h2>

            {}
            <p className="font-default text-steel-grey leading-relaxed mb-10 md:mb-12" style={{
            fontSize: "19px",
            maxWidth: "460px"
          }}>
              Equip your event with the tools for transformation. Download the
              official Damien Cole speaker sheet, high-res media assets, and
              booking availability for your next leadership summit or keynote.
            </p>

            {}
            <div className="flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-8">
              <Link to="/AboutPage">
                <Button size="lg" className="h-14 px-8 bg-primary text-primary-foreground hover:bg-primary/90 font-mono text-xs tracking-[0.2em] uppercase rounded-md" style={{
                boxShadow: "0 24px 60px -12px hsla(45, 100%, 50%, 0.3), 0 8px 24px -8px hsla(0, 0%, 0%, 0.6)"
              }}>
                  Download Speaker Sheet
                  <ArrowUpRight className="size-4" />
                </Button>
              </Link>

              <Link to="#" className="group inline-flex items-center gap-3 font-mono text-xs tracking-[0.2em] uppercase text-foreground border-b border-primary/30 pb-3 hover:border-primary hover:text-primary transition-colors duration-300">
                View Media Kit
                <ArrowDown className="size-3.5 group-hover:translate-y-0.5 transition-transform" />
              </Link>
            </div>
          </div>

          {}
          <div ref={cardRef} className={`col-span-12 lg:col-span-5 lg:pl-8 flex lg:items-center transition-all duration-1000 delay-200 ease-out ${cardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative w-full rounded-md p-8 md:p-10 border border-white/10" style={{
            background: "hsla(215, 20%, 15%, 0.7)",
            backdropFilter: "blur(20px) saturate(150%)",
            WebkitBackdropFilter: "blur(20px) saturate(150%)",
            boxShadow: "0 32px 80px -16px hsla(0, 0%, 0%, 0.8), inset 0 1px 0 hsla(0, 0%, 100%, 0.05)"
          }}>
              {}
              <div className="flex items-start justify-between mb-8 pb-6 border-b border-white/10">
                <div>
                  <div className="font-mono text-[10px] tracking-[0.25em] text-primary mb-2">
                    SIGNATURE TOPIC
                  </div>
                  <div className="font-mono text-[10px] tracking-[0.2em] text-muted-foreground">
                    SERIES / 2024
                  </div>
                </div>
                <div className="size-2 bg-primary" style={{
                boxShadow: "0 0 12px hsl(45 100% 50%)"
              }} />
              </div>

              {}
              <div className="grid grid-cols-2 gap-x-6 gap-y-6">
                {projectMeta.map((item, i) => <div data-index={i} key={i} className="flex flex-col gap-2">
                    <span className="font-mono text-[10px] tracking-[0.2em] text-muted-foreground uppercase">
                      {item.label}
                    </span>
                    <span className="font-mono text-xs tracking-wider text-foreground uppercase font-semibold">
                      {item.value}
                    </span>
                  </div>)}
              </div>

              {}
              <div className="mt-10 pt-6 border-t border-white/10 flex items-center justify-between">
                <span className="font-mono text-[10px] tracking-[0.25em] text-muted-foreground uppercase">
                  Booking / Availability
                </span>
                <Link to="#" className="inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.25em] uppercase text-primary hover:text-foreground transition-colors">
                  Check Dates
                  <ArrowUpRight className="size-3" />
                </Link>
              </div>

              {}
              <div className="absolute top-0 left-0 w-4 h-px bg-primary" />
              <div className="absolute top-0 left-0 h-4 w-px bg-primary" />
              <div className="absolute bottom-0 right-0 w-4 h-px bg-primary" />
              <div className="absolute bottom-0 right-0 h-4 w-px bg-primary" />
            </div>
          </div>
        </div>

        {}
        <div className="mt-20 md:mt-28 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 max-w-[1600px] mx-auto">
          <span className="font-mono text-[10px] tracking-[0.25em] text-muted-foreground uppercase">
            DAMIEN COLE / Leadership Division
          </span>
          <span className="font-mono text-[10px] tracking-[0.25em] text-muted-foreground uppercase">
            The Resilience Mindset — Global Keynotes
          </span>
        </div>
      </div>
    </section>;
}